<template>
  <v-container class="px-0">
    <h1 class="pa-2" v-if="decks">
      <span class="mr-5 headline pa-2">Review Subjects</span>
      <p class="px-2 body-1 grey--text">A comprehensive subject reivew. This will incorporate your individual deck practice.</p>
      <v-card hover flat outlined class="headline ma-1 pa-3 text-center" width="120" @click="$router.push({name: 'Review', params: {subject: 'Histology'}})">
        <div>
          <v-icon large class="pa-2 ">mdi-microscope</v-icon>
        </div>
        <p class="subtitle-1">Histology</p>
      </v-card>

    </h1>

    <h1 class="pa-2" v-if="decks">
      <span class="mr-5 headline pa-2">Indvidual Decks</span>
      <v-chip small dark color="blue lighten-2" v-if="tag" close @click:close="tag = null">Showing only {{tag}} tag</v-chip>
      <v-chip small dark :color="colorSubjects(singleSubject)" v-if="singleSubject" close @click:close="singleSubject = null">Showing only {{singleSubject}}</v-chip>
      <p class="px-2 body-1 grey--text">Focus on individual decks. Your progress will be reflected in your full subject review. <router-link v-if="isContentAdmin()" :to="{ name: 'ManageContent', params: {} }"> Manage Content</router-link></p>

    </h1>
    <v-row wrap v-if="decks">
      <v-flex xs6 class="px-3 mx-2">
        <v-text-field clearable prepend-inner-icon="mdi-magnify" append-icon label="Search" v-model="searchString"></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-autocomplete v-if="!tag" label="Tag" :items="uniqueTags" v-model="tag"></v-autocomplete>
      </v-flex>
    </v-row>
    <div v-if="decks">

      <v-card class="orange--text pa-2">
        <v-row wrap class="pa-2">
            <v-flex xs3 sm2 class="pl-2">Subject</v-flex>
            <v-flex xs5 sm5 class="pl-2">Deck Name</v-flex>
            <v-flex xs12 sm2 class="pl-2 hidden-xs-only">Lecture Date</v-flex>
            <v-flex xs4 sm2 class="pl-2">Progress</v-flex>

        </v-row>
      </v-card>

      <v-card hover class="pa-2" v-if="decks" v-for="deck in filteredDecks">
        <v-row wrap class="pa-2">
            <v-flex xs3 sm2 class="pl-2">
              <v-chip dark :color="colorSubjects(deck.subject)" @click="singleSubject = deck.subject">
                {{deck.subject}}
              </v-chip>
            </v-flex>
            <v-flex xs5 sm5 class="pl-2" @click="$router.push({ name: 'Learn', params: {id: deck.id, tag} })">
              {{deck.name}}
              <v-chip small color="red lighten-3" dark v-if="tag == 'incomplete'" v-for="tag in deck.tags">{{tag}}</v-chip>
            </v-flex>
            <v-flex class="pl-2 hidden-xs-only">{{deck.lectureDate}}</v-flex>
            <!-- <v-flex xs4 sm2 class="pl-2">{{lastPractice(deck)}}</v-flex> -->
            <v-flex xs4 sm2 class="pl-2">
              <span v-html="practiceProgress(deck)"></span>
              <v-progress-linear color="blue lighten-2" background-color="grey lighten-2" :value="practiceProgressBar(deck)" background-opacity="10"></v-progress-linear>

            </v-flex>
            <v-flex xs1 class="hidden-xs-only">
              <!-- <v-btn icon v-if="isDeckAdmin(deck)" @click="$router.push({name: 'ManageDeck', params: {id: deck.id, tag}})">
                <v-icon>mdi-settings-outline</v-icon>
              </v-btn> -->
            </v-flex>

        </v-row>

      </v-card>
      <h1 class="pa-2" v-if="decks && isContentAdmin()">
        <v-btn @click="$router.push({name: 'Browse'})">Browse Content (DevAdmin Only)</v-btn>
      </h1>
    </div>

    <v-dialog v-model="deckDialog" max-width="400" v-if="isAuth">
      <v-card class="pa-3">
        <v-form>
          <div>Add Deck</div>
          <v-text-field label="Deck Name" v-model="newDeck.name"></v-text-field>
          <v-text-field label="Subject" v-model="newDeck.subject"></v-text-field>
          <v-btn @click="createNewDeck()">Save Deck</v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  <v-progress-circular v-if="loading" class="center-element" large indeterminate :size="90" :width="15" color="orange"></v-progress-circular>
  </v-container>

</template>

<script>
import Obj from '@/objects'
import _ from 'underscore'
import moment from 'moment'
import firebase from 'firebase'
import db from '@/fb'

export default {
  name: 'Dashboard',
  data() {
    return {
      decks: null,
      loading: false,
      newDeck: null,
      deckDialog: null,
      tag: null,
      searchString: null,
      singleSubject: null,
      uniqueSubjects: null,
      uniqueTags: null,
      subjectColors: [
        'orange lighten-2',
        'blue lighten-2',
        'purple lighten-2',
        'green lighten-2',
        'pink lighten-2',
        'red lighten-2',
      ]
    }
  },
  computed: {
    isAuth() {
      if (firebase.auth().currentUser) {
        return true
      }
      else {
        return false
      }
    },
    filteredDecks() {
      let result = this.decks
      if (this.decks != null) {
        if (this.tag != null) {
          result = result.filter(entry => {
            return entry.tags.includes(this.tag)
          })

        }
        if (this.singleSubject != null) {
          result = result.filter(entry => {
            return entry.subject == this.singleSubject
          })

        }

        if (this.searchString != null) {
          result = result.filter(entry => {
            let entryString = entry.name + " " + entry.subject
            entryString = entryString.toLowerCase()

            if (entryString.includes(this.searchString.toLowerCase())){ // convert to lower case
                return true
              }
            else {
              return false
            }
          })
        }

        return result




      }
      else {
        return result
      }


    }

  },
  mounted() {
    if (this.$route.query.tag) {
      this.tag = this.$route.query.tag
    }
    if (this.$route.params.tag) {
      this.tag = this.$route.params.tag
    }
    console.log(this.dashboardTag)
    this.loading = true

    if (this.isAuth) {
      this.newDeck = Obj.createNewDeck()
    }

    //added for review calculations
    Obj.getUserInfo().then(userInfo => {
      //added try catch block to fix problem with first login that has not yet defined "hasReviewd"
      try {
        if (userInfo.hasReviewed == true) {
          console.log("processing review")
          Obj.updateDeckProgress().then(() => {
            this.setupDashboard()
          })
        }
        else {
          console.log("not review")
          this.setupDashboard()
        }

      }
      catch(err) {
        console.log("first login")
        this.setupDashboard()
      }


    })

  },
  methods: {
    setupDashboard() {
      Obj.getDecks().then(result => {
        let sort = result
        sort = _.sortBy(sort, 'lectureDate').reverse()
        sort = _.sortBy(sort, 'subject').reverse()

        this.decks = sort
        this.loading = false

        //prework for color subjects
        let subjects = []
        let tags = []
        this.decks.forEach(entry => {
          subjects.push(entry.subject)
        })
        this.uniqueSubjects = _.uniq(subjects)

        this.decks.forEach(entry => {
          tags.push(entry.tags)
        })
        tags = tags.flat()
        this.uniqueTags = _.uniq(tags)
      })
    },
    isContentAdmin() {
      let id = firebase.auth().currentUser.uid
      if (id == 'HSt6S2N9qHaG4sR2Uy6pYTMng123' || id == '0df9Ca74qQgSagtjcZmd3R9CM4w2') {
        return true
      }
      else {
        return false
      }
    },
    lastPractice(deck) {
      if (deck.deckState != null) {
        return moment(deck.deckState.timestamp).format("MMM-DD")
      }
      else {
        return "Never"
      }
    },
    practiceProgress(deck) {
      if (deck.deckState != null) {
        let total = deck.deckState.know + deck.deckState.review + deck.deckState.new
        let progress = '<span class="orange--text">' + deck.deckState.new +'</span>' + ' | '
        progress += '<span class="purple--text">' + deck.deckState.review +'</span>' + ' | '
        progress += '<span class="blue--text">' + deck.deckState.know +'</span>'
        progress += '<span class="grey--text">' + ' (' + total + ')' + '</span>'
        if (deck.deckState.new == 0 && deck.deckState.review == 0) {
          return '<span class="blue--text">Complete</span>'
        }
        return progress
      }
      else {
        return '<span class="grey--text">' + deck.deckLength + ' card deck</span>'
      }

    },
    practiceProgressBar(deck) {
      if (deck.deckState != null) {
        let total = deck.deckState.know + deck.deckState.review + deck.deckState.new
        let progress = (deck.deckState.know / total) * 100
        return progress
      }
      else {
        return 0
      }

    },
    colorSubjects(subject) {
      let index = this.uniqueSubjects.indexOf(subject)
      if (index > this.subjectColors.length) {
        return ""
      }
      else {
        return this.subjectColors[index]
      }
    },
    createNewDeck() {
      let doc = firebase.firestore().collection('decks').doc()
      doc.set(this.newDeck).then(result => {
        console.log(doc.id)
        this.newDeck = Obj.createNewDeck()
        this.deckDialog = false
        this.$router.push({name: 'ManageDeck', params: {id: doc.id}})
      })

    }


  }
}
</script>

<style>
.center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
